import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { NgClass } from "@angular/common";
import { HostUtil } from "../../utils/host-util";

interface IAppCategory {
  name: string;
  icon: string;
  apps: IApp[];
}

interface IApp {
  name: string;
  description: string;
  icon: string;
  url: string;
  current?: boolean;
}

@Component({
  templateUrl: './app-switcher-modal.component.html',
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppSwitcherModalComponent {
  public readonly categories: IAppCategory[] = [
    {
      name: 'Digital Signage',
      icon: 'pi pi-desktop',
      apps: [
        {
          name: 'User Dashboard',
          description: 'Verwalten Sie Ihre Bildschirme und Inhalte',
          icon: 'pi pi-th-large',
          url: '',
          current: true
        },
        {
          name: 'Developer Dashboard',
          description: 'Entwickeln Sie Apps und Widgets',
          icon: 'pi pi-code',
          url: HostUtil.getDeveloperDashboardSiteUrl()
        },
        {
          name: 'Vendor Dashboard',
          description: 'Verkaufen Sie Ihre Apps im Marktplatz',
          icon: 'pi pi-shop',
          url: HostUtil.getVendorDashboardSiteUrl()
        }
      ]
    },
    {
      name: 'Business Portal',
      icon: 'pi pi-briefcase',
      apps: [
        {
          name: 'Business Portal',
          description: 'Verwalten Sie Unternehmen und Agents',
          icon: 'pi pi-briefcase',
          url: HostUtil.getBusinessPortalDashboardSiteUrl()
        }
      ]
    }
  ];

  public readonly selectedCategory: WritableSignal<IAppCategory> = signal(this.categories[0]);

  constructor(private readonly _dynamicDialogRef: DynamicDialogRef) {
  }

  public selectCategory(category: IAppCategory): void {
    this.selectedCategory.set(category);
  }

  public navigateToApp(app: IApp): void {
    if (app.current) {
      this._dynamicDialogRef.close();
      return;
    }
    location.href = app.url;
  }

  public close(): void {
    this._dynamicDialogRef.close();
  }
}
